module.exports = __webpack_public_path__ + "img/dantaxi-header-new.ee18dfcd.jpg";